import { Flex } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { chartGroupMap } from 'packages/portfolio/ui/borrowingBase/portfolioBorrowingBaseChartConfigs';
import { PortfolioEligibilityKickoutsChart } from 'packages/portfolio/ui/borrowingBase/PortfolioBorrowingBaseEligibilityChart';
import { PortfolioCoreBorrowingBaseChartTemplate } from 'packages/portfolio/ui/shared/PortfolioCoreBorrowingBaseChartTemplate';

export const EligibilityContainerV2 = () => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <Flex direction="column" gap="2.5rem">
      {_.map(chartGroupMap.eligibility, (chart) => {
        return (
          <PortfolioCoreBorrowingBaseChartTemplate
            creditFacilityId={creditFacilityId}
            chartTitle={chart.chartTitle}
            chartConfig={chart.config}
            key={`portfolio-borrowing-base-chart-${chart.chartTitle}`}
          />
        );
      })}
      <PortfolioEligibilityKickoutsChart
        creditFacilityId={creditFacilityId}
        chartTitle="Eligibility Kickouts"
      />
    </Flex>
  );
};
